import React, { useState, useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { serialsNavigationMain } from "@/constants/serials";
import { navigateSerial } from "@/composable/useRoute";
import { Spin } from "antd";
import { LoadingOutlined } from "@ant-design/icons";
import { notification } from "antd";

import { removeFromList } from '@/utils/list';

import api from "@/api/index";

import AppHeader from "../components/header/AppHeader";
import Navigation from "@/components/navigation/Navigation";
import SerialSeasonSection from "@/components/season/SerialSeasonSection";

import "../styles/serial-season.scss";

function SerialSeason() {
  const [seasons, setSeasons] = useState([]);
  const [isLoading, setIsLoading] = useState<boolean>(true);
  const [isError, setIsError] = useState<boolean>(false);
  const [serial, setSerial] = useState(null)

  const { id } = useParams();
  const navigate = useNavigate();

  const linkBack: string = `/serial/${id}`;

  const onUpdateNav = (key: string) => {
    const url = navigateSerial(key, id);

    navigate(url);
  };

  const handleAddSeason = () => {
    setSeasons((prevSeasons) => [...prevSeasons, {}]);
  };

  const onRemoveSeason = async (season_id: number, index:number) => {
    try {
      if(!season_id) {
        const list = removeFromList(seasons, index);
        setSeasons(list);
        return;
      }

      await api.season.removeSeason(id, season_id);
      notification.success({
        message: "Сезон успешно удален",
      });
      fetchSeasons()
    } catch (err) {
      console.error(err);

      notification.error({
        message: "Ошибка при удалении сериала",
      });
    }
  };

  const fetchSeasons = async () => {
    try {
      setIsError(false);
      setIsLoading(true);
      setSeasons([]);

      const response = await api.seasons.getFromSerial(id);

      setSeasons(response?.data?.data?.seasons || []);

    } catch (err) {
      console.error(err);
      setIsError(true);
    } finally {
      setIsLoading(false);
    }
  };

  const handleUpdateSeasons = () => {
    fetchSeasons()
  }

  const featchSereal = async() => {
    try {
      const response = await api.serie.get(id)

      setSerial(response.data.data || {})

    } catch(err) {
      setSerial({})
    }
  }

  useEffect(() => {
    fetchSeasons();
    featchSereal()
  }, []);

  return (
    <div className="app-page serial-season">
      <AppHeader title={"Редактирование сериала"} link={linkBack} />

      <div className={"app-container"}>
        <div className="serial-season__control">
          <h3 className={"serial-season__name"}>
            { serial ? serial.title : ''}
          </h3>

          <a href={'#SectionsEnd'} className="app-btn serial-season__add" onClick={handleAddSeason}>
            Добавить сезон
          </a>
        </div>
      </div>

      {isLoading && (
          <div className="film-view__loader">
            <Spin size="large" indicator={<LoadingOutlined />} />
          </div>
      )}

      {!isLoading && !isError && (
        <div className="app-container serial-season__container">
          <Navigation
            defaultActiveLink="serial-seasons"
            links={serialsNavigationMain}
            update={onUpdateNav}
          />

          {seasons && (
            <div className="serial-season__sections">
              {seasons.map((season, index) => {
                return (
                  <SerialSeasonSection
                    key={index}
                    index={index}
                    season={season}
                    serial_id={id}
                    serial={serial}

                    remove={onRemoveSeason}
                    update={handleUpdateSeasons}
                  />
                );
              })}

              <div id={"SectionsEnd"}></div>
            </div>
          )}
        </div>
      )}
    </div>
  );
}

export default SerialSeason;
